import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, ListItem } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';

/** One catalog row: form name on the left, trailing checkbox. The whole row toggles. */
const AddFormsOption = ({ classes, form, checked, onToggle }) => (
  <ListItem
    button
    className={classes.listItem}
    onClick={() => onToggle(form.id)}
    data-testid={`add-forms-option-${form.id}`}
  >
    <Typography className={classes.formName}>{form.name}</Typography>
    <Checkbox
      className={classes.checkbox}
      checked={checked}
      tabIndex={-1}
      disableRipple
      inputProps={{ 'aria-label': form.name }}
    />
  </ListItem>
);

AddFormsOption.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  form: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }).isRequired,
  checked: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

AddFormsOption.defaultProps = {
  checked: false,
};

export default AddFormsOption;
